function arrayMove<T>(arr: T[], fromIndex: number, toIndex: number) {
  if (toIndex >= arr.length) {
    let k = toIndex - arr.length + 1;
    // eslint-disable-next-line no-plusplus
    while (k--) {
      arr.push(undefined as T);
    }
  }
  arr.splice(toIndex, 0, arr.splice(fromIndex, 1)[0]);
}

export default arrayMove;
